import { FC, MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import { Button, ButtonProps, DialogActions, DialogContent, DialogProps, DialogTitle } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { CloseButton, Dialog } from "./Dialog.style";

type DialogButtonProps = ButtonProps & { label?: string };

export interface AppDialogProps extends DialogProps {
  CancelButtonProps?: DialogButtonProps;
  ConfirmButtonProps?: DialogButtonProps;
  onClose: () => void;
}

const AppDialog: FC<AppDialogProps> = ({
  title,
  children,
  CancelButtonProps: { label: cancelLabel, onClick: onClickCancel, ...btnCancelProps } = {},
  ConfirmButtonProps: { label: confirmLabel, ...btnConfirmProps } = {},
  onClose,
  ...otherProps
}) => {
  const { t: getLabel } = useTranslation();
  const btnConfirmLabel = confirmLabel || getLabel("L_CONFIRM");
  const btnCancelLabel = cancelLabel || getLabel("L_CANCEL");

  const handleClose = (event: MouseEvent<HTMLButtonElement>) => {
    if (onClose) onClose();
    if (onClickCancel) onClickCancel(event);
  };

  return (
    <Dialog {...otherProps}>
      <DialogTitle>
        {title}
        <CloseButton onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
      </DialogTitle>

      <DialogContent>{children}</DialogContent>

      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose} {...btnCancelProps}>
          {btnCancelLabel}
        </Button>
        <Button variant="contained" {...btnConfirmProps}>
          {btnConfirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppDialog;
